/* ARAMA ÖNERİLERİ — 29 Eyl 2026 (kullanıcı: "arama çubuğu gerçek zamanlı öneriler göstersin").
   Başlıktaki her form[data-arama] için: odakta (boşken) son aramalar + popüler aramalar + çok
   satanlar (#AonBos şablonu); yazarken Shopify /search/suggest.json → arama önerileri, kategoriler,
   rehberler ve ürünler (fiyat, eski fiyat, tükendi). Erişilebilirlik: combobox + listbox,
   ↑/↓ ile gezinme, Enter seçer, Esc kapatır; fare/dokunma aynı seçenekleri kullanır.
   Tükenen ürün soluk ve tıklanamaz (26 Eyl kuralı). Temaya ek bağımlılık yok. */
(function () {
  'use strict';
  var formlar = document.querySelectorAll('form[data-arama]');
  var ayar = document.querySelector('[data-aon-ayar]');
  if (!formlar.length || !ayar || !window.fetch) return;

  var ONERI_URL = (ayar.getAttribute('data-oneri-url') || '/search/suggest') + '.json';
  var ARAMA_URL = ayar.getAttribute('data-arama-url') || '/search';
  var PARA = ayar.getAttribute('data-para') || '{{amount}}';
  var WA = ayar.getAttribute('data-wa') || '';
  var BOS = document.getElementById('AonBos');
  var PERDE = document.querySelector('[data-aon-perde]');
  var SON_ANAHTAR = 'ark_son_aramalar';
  var onbellek = {};
  var MQ_MASA = window.matchMedia('(min-width: 990px)');

  var IKON = {
    ara: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>',
    kat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></svg>',
    kitap: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 7v14"/><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/></svg>',
    ok: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m9 18 6-6-6-6"/></svg>',
    saat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 7v5.4l3.4 2"/></svg>'
  };

  /* ---------------------------------------------------------------- yardımcılar */
  var KATLA = { 'ç': 'c', 'Ç': 'c', 'ğ': 'g', 'Ğ': 'g', 'ı': 'i', 'I': 'i', 'İ': 'i', 'ö': 'o', 'Ö': 'o', 'ş': 's', 'Ş': 's', 'ü': 'u', 'Ü': 'u', 'â': 'a', 'Â': 'a', 'î': 'i', 'Î': 'i', 'û': 'u', 'Û': 'u' };
  function katla(s) {            /* harf başına 1:1 (uzunluk korunur) — vurgu konumları için */
    var o = '';
    for (var i = 0; i < s.length; i++) { var c = s.charAt(i); o += KATLA[c] || c.toLowerCase().charAt(0); }
    return o;
  }
  function kacis(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function vurgula(metin, sorgu) {
    metin = String(metin || '');
    var km = katla(metin), isaret = [], i, k;
    katla(sorgu).split(/\s+/).forEach(function (t) {
      if (t.length < 2) return;
      i = km.indexOf(t);
      while (i !== -1) { for (k = i; k < i + t.length; k++) isaret[k] = true; i = km.indexOf(t, i + t.length); }
    });
    var out = '', acik = false;
    for (i = 0; i < metin.length; i++) {
      if (isaret[i] && !acik) { out += '<mark>'; acik = true; }
      if (!isaret[i] && acik) { out += '</mark>'; acik = false; }
      out += kacis(metin.charAt(i));
    }
    return acik ? out + '</mark>' : out;
  }
  function para(tutar) {
    var n = parseFloat(tutar);
    if (isNaN(n)) return '';
    function bicim(x, bin, ond, hane) {
      var p = x.toFixed(hane).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, bin);
      return p[1] ? p[0] + ond + p[1] : p[0];
    }
    return PARA.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, t) {
      if (t === 'amount_no_decimals') return bicim(n, ',', '.', 0);
      if (t === 'amount_with_comma_separator') return bicim(n, '.', ',', 2);
      if (t === 'amount_no_decimals_with_comma_separator') return bicim(n, '.', ',', 0);
      return bicim(n, ',', '.', 2);
    });
  }
  function kucukGorsel(url, en) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + en;
  }
  function aramaAdresi(q) {
    return ARAMA_URL + '?q=' + encodeURIComponent(q) + '&type=product%2Carticle';
  }

  /* ---------------------------------------------------------------- son aramalar */
  function sonOku() {
    try { var v = JSON.parse(localStorage.getItem(SON_ANAHTAR) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function sonYaz(q) {
    q = String(q || '').trim();
    if (q.length < 2) return;
    try {
      var liste = sonOku().filter(function (x) { return katla(x) !== katla(q); });
      liste.unshift(q);
      localStorage.setItem(SON_ANAHTAR, JSON.stringify(liste.slice(0, 6)));
    } catch (e) { /* gizli pencere vb. — öneri yine çalışır */ }
  }
  function sonSil() { try { localStorage.removeItem(SON_ANAHTAR); } catch (e) { /* yok say */ } }

  /* ---------------------------------------------------------------- HTML üretimi */
  function bolum(baslik, ic, sinif) {
    return '<div class="aon__baslik">' + baslik + '</div><ul class="' + sinif + '" role="presentation">' + ic + '</ul>';
  }
  function sonucHtml(q, r) {
    var urunler = r.products || [], kat = r.collections || [], sorgular = r.queries || [], yazilar = r.articles || [];
    if (!urunler.length && !kat.length && !yazilar.length) {
      var ipucu = '<div class="aon__yok"><p class="aon__yok-bas"><b>“' + kacis(q) + '”</b> için öneri bulamadık.</p>' +
        '<p>Yazımı kontrol et ya da daha genel bir kelime dene.</p>';
      if (WA) {
        ipucu += '<a class="aon__wa" data-aon-secenek role="option" target="_blank" rel="noopener" href="' + kacis(WA + '?text=' +
          encodeURIComponent('Merhaba, sitede "' + q + '" aradım ama bulamadım. Yardımcı olabilir misiniz?')) + '">' +
          '<span>Aradığını bulamadın mı? <b>WhatsApp’tan sor</b></span>' + IKON.ok + '</a>';
      }
      return ipucu + '</div><div data-aon-populer></div>';
    }
    var yan = '', ana = '', html;
    if (sorgular.length) {
      yan += bolum('Öneriler', sorgular.slice(0, 4).map(function (s) {
        return '<li role="presentation"><a class="aon__oneri" role="option" data-aon-secenek data-aon-terim="' + kacis(s.text) + '" href="' + kacis(s.url) + '">' +
          IKON.ara + '<span>' + vurgula(s.text, q) + '</span></a></li>';
      }).join(''), 'aon__liste');
    }
    if (kat.length) {
      yan += bolum('Kategoriler', kat.slice(0, 4).map(function (c) {
        return '<li role="presentation"><a class="aon__kat" role="option" data-aon-secenek href="' + kacis(c.url) + '">' +
          IKON.kat + '<span>' + vurgula(c.title, q) + '</span></a></li>';
      }).join(''), 'aon__liste');
    }
    if (yazilar.length) {
      yan += bolum('Rehberler', yazilar.slice(0, 3).map(function (a) {
        return '<li role="presentation"><a class="aon__rehber" role="option" data-aon-secenek href="' + kacis(a.url) + '">' +
          IKON.kitap + '<span>' + vurgula(a.title, q) + '</span></a></li>';
      }).join(''), 'aon__liste');
    }
    if (urunler.length) {
      ana = bolum('Ürünler', urunler.slice(0, 6).map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        var fiyat = '<span class="aon__fiyat"><b>' + kacis(para(p.price)) + '</b>' +
          (parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + kacis(para(p.compare_at_price_max)) + '</s>' : '') + '</span>';
        var ic = '<span class="aon__urun-img">' + (img ? '<img src="' + kacis(kucukGorsel(img, 120)) + '" alt="" width="52" height="52" loading="lazy">' : '') + '</span>' +
          '<span class="aon__urun-txt"><span class="aon__urun-ad">' + vurgula(p.title, q) + '</span>' +
          (p.available ? fiyat : '<span class="aon__tukendi">Tükendi</span>') + '</span>';
        return p.available
          ? '<li role="presentation"><a class="aon__urun" role="option" data-aon-secenek href="' + kacis(p.url) + '">' + ic + '</a></li>'
          : '<li role="presentation"><span class="aon__urun is-tukendi" role="option" aria-disabled="true">' + ic + '</span></li>';
      }).join(''), 'aon__urunler');
    }
    html = '<div class="aon__sonuc' + (yan && ana ? '' : ' aon__sonuc--tek') + '">' +
      (ana ? '<div class="aon__ana">' + ana + '</div>' : '') +
      (yan ? '<div class="aon__yan">' + yan + '</div>' : '') + '</div>' +
      '<a class="aon__tumu" role="option" data-aon-secenek data-aon-terim="' + kacis(q) + '" href="' + kacis(aramaAdresi(q)) + '">' +
      '<span>“' + kacis(q) + '” için tüm sonuçları gör</span>' + IKON.ok + '</a>';
    return html;
  }

  /* ---------------------------------------------------------------- form başına davranış */
  var sayac = 0;
  formlar.forEach(function (form) {
    var girdi = form.querySelector('input[type="search"]');
    var panel = form.querySelector('[data-aon-panel]');
    var temizle = form.querySelector('[data-aon-temizle]');
    if (!girdi || !panel) return;
    var onek = 'aon' + (++sayac) + '-';
    var aktif = -1, zaman = null, kontrol = null, sonQ = null, acik = false;

    function secenekler() {
      return Array.prototype.slice.call(panel.querySelectorAll('[data-aon-secenek]'));
    }
    function kimlikVer() {
      secenekler().forEach(function (el, i) { el.id = onek + i; el.setAttribute('aria-selected', 'false'); });
      aktif = -1;
      girdi.removeAttribute('aria-activedescendant');
    }
    function aktifYap(i, kaydir) {
      var s = secenekler();
      if (!s.length) return;
      if (aktif > -1 && s[aktif]) { s[aktif].classList.remove('is-aktif'); s[aktif].setAttribute('aria-selected', 'false'); }
      aktif = i;
      if (i < 0 || !s[i]) { girdi.removeAttribute('aria-activedescendant'); return; }
      s[i].classList.add('is-aktif');
      s[i].setAttribute('aria-selected', 'true');
      girdi.setAttribute('aria-activedescendant', s[i].id);
      if (kaydir) s[i].scrollIntoView({ block: 'nearest' });
    }
    function ac() {
      if (acik) return;
      acik = true;
      panel.hidden = false;
      form.classList.add('is-aon');
      girdi.setAttribute('aria-expanded', 'true');
      if (PERDE && !MQ_MASA.matches) { PERDE.hidden = false; document.documentElement.classList.add('aon-acik'); }
    }
    function kapat() {
      if (!acik) return;
      acik = false;
      panel.hidden = true;
      form.classList.remove('is-aon');
      girdi.setAttribute('aria-expanded', 'false');
      girdi.removeAttribute('aria-activedescendant');
      aktif = -1;
      if (PERDE) { PERDE.hidden = true; document.documentElement.classList.remove('aon-acik'); }
    }
    function populerEkle() {
      var yer = panel.querySelector('[data-aon-populer]');
      if (!yer || !BOS) return;
      var kopya = BOS.content.cloneNode(true);
      var cip = kopya.querySelector('.aon__cipler:not([data-aon-son-liste])');
      if (cip) {
        var bas = document.createElement('div');
        bas.className = 'aon__baslik';
        bas.textContent = 'Popüler aramalar';
        yer.appendChild(bas);
        yer.appendChild(cip);
      }
    }
    function bosGoster() {
      sonQ = '';
      if (!BOS) { kapat(); return; }
      panel.innerHTML = '';
      panel.appendChild(BOS.content.cloneNode(true));
      var son = sonOku(), kutu = panel.querySelector('[data-aon-son]'), liste = panel.querySelector('[data-aon-son-liste]');
      if (kutu && liste && son.length) {
        liste.innerHTML = son.map(function (q) {
          return '<li role="presentation"><a class="aon__cip aon__cip--son" role="option" data-aon-secenek data-aon-terim="' + kacis(q) + '" href="' + kacis(aramaAdresi(q)) + '">' +
            IKON.saat + '<span>' + kacis(q) + '</span></a></li>';
        }).join('');
        kutu.hidden = false;
      }
      kimlikVer();
      ac();
    }
    function goster(q, veri) {
      if (q !== girdi.value.trim()) return;           /* bayat yanıt */
      panel.innerHTML = sonucHtml(q, veri);
      populerEkle();
      kimlikVer();
      ac();
    }
    function getir(q) {
      if (onbellek[q]) { goster(q, onbellek[q]); return; }
      if (kontrol) kontrol.abort();
      kontrol = window.AbortController ? new AbortController() : null;
      form.classList.add('is-yukleniyor');
      var adres = ONERI_URL + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query,article&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last';
      fetch(adres, { headers: { Accept: 'application/json' }, signal: kontrol ? kontrol.signal : undefined })
        .then(function (y) { if (!y.ok) throw new Error(y.status); return y.json(); })
        .then(function (j) {
          var r = (j && j.resources && j.resources.results) || {};
          onbellek[q] = r;
          form.classList.remove('is-yukleniyor');
          goster(q, r);
        })
        .catch(function (e) { if (e && e.name === 'AbortError') return; form.classList.remove('is-yukleniyor'); });
    }
    function degisti() {
      var q = girdi.value.trim();
      if (temizle) temizle.hidden = !girdi.value;
      clearTimeout(zaman);
      if (q.length < 2) { if (sonQ !== '') bosGoster(); else ac(); return; }
      if (q === sonQ && acik) return;
      sonQ = q;
      zaman = setTimeout(function () { getir(q); }, onbellek[q] ? 0 : 140);
    }

    girdi.addEventListener('focus', function () {
      if (girdi.value.trim().length >= 2) { sonQ = null; degisti(); } else bosGoster();
    });
    girdi.addEventListener('input', degisti);
    girdi.addEventListener('keydown', function (e) {
      var s = secenekler();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!acik) { degisti(); return; }
        if (s.length) aktifYap(aktif + 1 >= s.length ? 0 : aktif + 1, true);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (s.length) aktifYap(aktif - 1 < 0 ? s.length - 1 : aktif - 1, true);
      } else if (e.key === 'Enter') {
        if (acik && aktif > -1 && s[aktif]) {
          e.preventDefault();
          sonYaz(s[aktif].getAttribute('data-aon-terim') || girdi.value);
          s[aktif].click();
        }
      } else if (e.key === 'Escape') {
        if (acik) { e.preventDefault(); kapat(); }
      } else if (e.key === 'Tab') {
        kapat();
      }
    });
    panel.addEventListener('mousemove', function (e) {
      var el = e.target.closest('[data-aon-secenek]');
      if (!el) return;
      var i = secenekler().indexOf(el);
      if (i !== aktif) aktifYap(i, false);
    });
    panel.addEventListener('mousedown', function (e) {
      if (e.target.closest('[data-aon-secenek], [data-aon-son-sil]')) e.preventDefault();   /* odak girdide kalsın */
    });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-aon-son-sil]')) {
        e.preventDefault();
        sonSil();
        var kutu = panel.querySelector('[data-aon-son]');
        if (kutu) kutu.remove();
        kimlikVer();
        girdi.focus();
        return;
      }
      var el = e.target.closest('[data-aon-secenek]');
      if (el) sonYaz(el.getAttribute('data-aon-terim') || girdi.value);
    });
    if (temizle) {
      temizle.addEventListener('click', function () {
        girdi.value = '';
        temizle.hidden = true;
        girdi.focus();
        bosGoster();
      });
      temizle.hidden = !girdi.value;
    }
    form.addEventListener('submit', function (e) {
      if (!girdi.value.trim()) { e.preventDefault(); girdi.focus(); return; }
      sonYaz(girdi.value);
      kapat();
    });
    document.addEventListener('pointerdown', function (e) {
      if (!acik) return;
      if (form.contains(e.target)) return;
      kapat();
    });
    if (PERDE) PERDE.addEventListener('click', kapat);
    /* geri tuşuyla dönülen sayfada panel açık kalmasın (bfcache) */
    window.addEventListener('pageshow', function (e) { if (e.persisted) kapat(); });
  });
})();
